export const auth = (state = {}, action) => {

    switch (action.type) {
        case "LOG_IN": const auth = { ...action.value, loggedIn: true };
            console.log("LOG_IN : " + JSON.stringify(auth));

            return { ...state, ...auth }; //el action.value aveces se encuentra como action.payload
        case "LOG_OUT": //console.log("LOG_OUT");
            return {
                ...state,
                loggedIn: false,
                nombre: "",
                telefono: "",
                usuarioInt: "",
                email: "",

            }; //el action.value aveces se encuentra como action.payload
        default:
            //console.log("LOG_default->" + action.type);
            return state;
    }
}